import { VinceApp } from '../composables/usePermission';
import { useMenuStore } from '../stores/menuStore';
import { Action } from '../types/roles';
import { Menu, SubHeader } from 'vince-core/types/menu';
import { ResourceType } from 'vince-core/types/common';
import { URL_LATEST_UPDATES, URL_DOCUMENTATION, URL_SUPPORT } from 'vince-core/constants/common';

export default defineNuxtPlugin(() => {
    const store = useMenuStore();
    store.addMenuItem('menus.subMenus.auditLog', '/audit-logs', 1, Menu.ADMINISTRATION, SubHeader.REPORTS, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.TENANT,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.latestUpdates', URL_LATEST_UPDATES, 3, Menu.ADMINISTRATION, SubHeader.EXTERNAL, 'pi pi-external-link', undefined);
    store.addMenuItem('menus.subMenus.documentation', URL_DOCUMENTATION, 4, Menu.ADMINISTRATION, SubHeader.EXTERNAL, 'pi pi-external-link');
    store.addMenuItem('menus.subMenus.support', URL_SUPPORT, 5, Menu.ADMINISTRATION, SubHeader.EXTERNAL, 'pi pi-external-link');

    // POC
    // store.addMenuItem('menus.subMenus.fb', '/form-builder', 200, Menu.Info);

    // Access Management Items
    store.addMenuItem('menus.subMenus.tenants', '/access-management/tenants', 1, Menu.ADMINISTRATION, SubHeader.ADMINISTRATION, 'pi pi-building', {
        app: VinceApp.SYS_ADMIN,
        resource: ResourceType.TENANT,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.users', '/access-management/users', 2, Menu.ADMINISTRATION, SubHeader.ADMINISTRATION, 'pi pi-users', {
        app: VinceApp.FND,
        resource: ResourceType.USER,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.roles', '/access-management/roles', 3, Menu.ADMINISTRATION, SubHeader.ADMINISTRATION, 'pi pi-id-card', {
        app: VinceApp.FND,
        resource: ResourceType.ROLE,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.apiClients', '/access-management/api-clients', 4, Menu.ADMINISTRATION, SubHeader.ADMINISTRATION, 'pi pi-workflows', {
        app: VinceApp.FND,
        resource: ResourceType.APICLIENT,
        resourceId: '*',
        action: '*'
    });

    store.addMenuItem('menus.subMenus.tableManagement', '/tables', 4, Menu.MAIN, undefined, 'pi pi-table', {
        app: VinceApp.CUSTOM_TABLES,
        resource: ResourceType.META,
        resourceId: '*',
        action: Action.READ
    });

    // Workflow Settings
    store.addMenuItem('menus.subMenus.connections', '/connections', 1, Menu.ADMINISTRATION, SubHeader.WORKFLOW_SETTINGS, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.CONNECTION,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.environments', '/environments', 2, Menu.ADMINISTRATION, SubHeader.WORKFLOW_SETTINGS, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.ENVIRONMENT,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.groups', '/groups', 2, Menu.ADMINISTRATION, SubHeader.WORKFLOW_SETTINGS, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.GROUP,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.schedules', '/schedules', 3, Menu.ADMINISTRATION, SubHeader.WORKFLOW_SETTINGS, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.WORKFLOW,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.variables', '/variables', 4, Menu.ADMINISTRATION, SubHeader.WORKFLOW_SETTINGS, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.VARIABLE,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.webhooks', '/webhooks', 5, Menu.ADMINISTRATION, SubHeader.WORKFLOW_SETTINGS, undefined, {
        app: VinceApp.FND,
        resource: ResourceType.WEBHOOK,
        resourceId: '*',
        action: '*'
    });

    // Settings
    store.addMenuItem('company.tabs.information', '/company/information', 1, Menu.ADMINISTRATION, SubHeader.COMPANY_SETTINGS, 'pi pi-building', {
        app: VinceApp.FND,
        resource: ResourceType.TENANT,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('company.tabs.scim', '/company/scim', 2, Menu.ADMINISTRATION, SubHeader.COMPANY_SETTINGS, 'pi pi-id-card', {
        app: VinceApp.FND,
        resource: ResourceType.TENANT,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('company.tabs.singlesignon', '/company/sso', 3, Menu.ADMINISTRATION, SubHeader.COMPANY_SETTINGS, 'pi pi-tags', {
        app: VinceApp.FND,
        resource: ResourceType.TENANT,
        resourceId: '*',
        action: '*'
    });
    store.addMenuItem('menus.subMenus.userProfile', '/user-profile', 5, Menu.SETTINGS, undefined, 'pi pi-user');
});
